import { render } from "./ButtonInner.vue?vue&type=template&id=c19a37f0"
import script from "./ButtonInner.vue?vue&type=script&lang=js"
export * from "./ButtonInner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__